module.exports = __webpack_public_path__ + "static/media/logo.b29da9ac.png";